import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Australia extends Component {
	state={
		mingxiao:[
			{
				name:'悉尼大学 University of Sydney',
				content:'悉尼大学始建于 1850 年，坐落于澳大利亚第一大城市悉尼，是一所世界顶尖研究型学府。悉尼大学是澳大利亚六所砂岩学府之一，也是澳大利亚八大名校的核心盟校成员。悉尼大学的毕业生掌控着澳洲的政治、经济命脉。' +
					'毕业生中不乏总理、最高法院法官、联合国大会主席、世界银行总裁以及诺贝尔奖得主等活跃在政治经济平台的杰出人士。',
				zhuanye:['澳洲留学优势科目','法律','商科']
			},
			{
				name:'墨尔本大学 University of Melbourne',
				content:'墨尔本大学坐落于澳大利亚墨尔本市，始建于 1853 年，是澳大利亚历最古老和最杰出的大学之一，同时也是八大名校的核心盟校成员。在科研、创新、教学等领域一直保持领先地位。' +
					'墨尔本大学的学习环境和课程具有国际多样性及文化多元性，吸引了全球各地才华横溢的人才到此学习、工作和访问。',
				zhuanye:['澳洲留学优势科目','MBA','医科','法律']
			},
			{
				name:'澳洲国立大学 Australian National University',
				content:'澳大利亚国立大学位于澳大利亚首都堪培拉，是澳大利亚唯一由联邦国会专门单独立法而创立的大学，连续多年在澳大利亚大学排行榜上名列第 1 ，在各世界大学排行榜上多次名列全世界前 20 。' +
					'作为澳大利亚唯一享有“国立”资格的学府，其许多学科的学术地位在澳大利亚独占鳌头，以其卓着的学术成果、高素质的研究人员而着称，成为澳大利亚高级科研人员向往的圣地。',
				zhuanye:['澳洲留学优势科目','工程','理科']
			},
			{
				name:'昆士兰大学 University of Queensland',
				content:'新南威尔士大学成立于 1949 年，是的一所国际着名研究型高等学府。其强项学科为商科和工科并在亚太区享有盛誉。作为澳大利亚八大名校之一，是培养出最多百万富翁的澳洲大学。' +
					'新南威尔士大学非常注重教育与科研的跨国界交流与发展，大约有来自 135 个国家的近 9000 多名国际留学生在校学习。',
				zhuanye:['澳洲留学优势科目','医学','法律','商科']
			},
			{
				name:'阿德雷德大学 University of Adelaide',
				content:'阿德雷德大学始建于 1874 年，是澳大利亚第三所最古老的大学。阿德雷德大学有着优良的传统：创新和高质量的科研以及优秀的教学都为学生的学习提供保证。' +
					'他把传统的优势和现代艺术特色及丰富的学生生活相结合，是澳大利亚政府对大学生综合测评后推举的最优秀的大学之一。',
				zhuanye:['澳洲留学优势科目','会计','生物科学','信息工程']
			},
			{
				name:'新南威尔士大学 University of New South Wales',
				content:'新南威尔士大学成立于 1949 年，是的一所国际着名研究型高等学府。其强项学科为商科和工科并在亚太区享有盛誉。' +
					'作为澳大利亚八大名校之一，是培养出最多百万富翁的澳洲大学。新南威尔士大学非常注重教育与科研的跨国界交流与发展，大约有来自 135 个国家的近 9000 多名国际留学生在校学习。',
				zhuanye:['澳洲留学优势科目','工程','商科']
			},
			{
				name:'西澳大学 University of Western Malaysia',
				content:'西澳大学建立于 1911 年，是澳大利亚最为优良的五星级大学之一。每年西澳大学在科研方面的投入达到 1700 万元。' +
					'每年毕业生中有超过 250 名博士生，名列前茅，毕业生在获得全职工作方面始终强于所有澳洲西部其他大学，在全澳洲大学统计中也稳居前列。其显着特点就是重视研究及研究培训。',
				zhuanye:['澳洲留学优势科目','医学','法律','建筑','教育']
			},
			{
				name:'蒙纳士大学 Monash University',
				content:'蒙纳士大学是澳洲最大的大学之一，同时也是世界前百强大学。蒙纳士大学拥有自己的蒙纳士学院，为国际留学生进入蒙纳士大学提供特殊通路，' +
					'国际留学生可以通过在蒙纳士大学的学习后，直接进入蒙纳士大学学习，最终同样获得蒙纳士大学学位文凭。',
				zhuanye:['澳洲留学优势科目','法律','医学','商科']
			},
			{
				name:'昆士兰科技大学 Queensland University of Technology',
				content:'昆士兰科技大学于 1908 年建校，历史悠久，声誉卓着。学校的教学注重结合实际应用，学校的研究和教育方向以符合就业市场的需求为主，学生经常参与业界的实际方案研讨。' +
					'昆士兰科技大学的国际学生服务处可为学生提供重要的帮助和支持，以满足国际学生的所有需要，多元文化顾问可以帮助学生解决个人、经济和社会方面的问题或忧虑。',
				zhuanye:['澳洲留学优势科目','法律','商科','教育']
			},
			{
				name:'纽卡斯尔大学 University of Newcastle',
				content:'纽卡斯尔大学成立于 1965 年，不论在教育还是在研究领域，在澳大利亚都居领先及创新地位，吸引了世界各地高素质的学生和教学人员，也是国际上公认的“由问题指导学习”方法的先驱。',
				zhuanye:['澳洲留学优势科目','医学','保健','工程','护理']
			},
		],
		list:[
			{
				title:'TESOL专业',
				content:'全称是Teaching English to Speakers of Other Languages，和国内的对外汉语差不多，属于对外英语，是一门偏文科和教育向的专业，不属于高薪行列，但是市场需求一直很大。<br/> <br/>而且随着国际化程度的加深，英语的普及和覆盖面越越来越广，对于专业的教学人才的需求只会增加不会减少，大家进入国际市场求职，也不会有很大的阻力，而澳洲各大名校的相关教育是非常成熟的。',
				img:require('../../static/images/oceania_img2.png')
			},
			{
				title:'景观建筑',
				content:'专业的教学注重培养学生的设计、分析好规划的能力，具有非常强的实用性，而且还会开设最长半年的实践课程，让学生能够深入到实习之中，大家可以积累下丰富的经验。<br/><br/>而且这份属于非社会发展必须要有的行业，不过当大家的基本需求得到满足后，质量的需求会增加，大家可以的求职岗位，在几年前可能没有听说过，但是现在却属于高薪行业。',
				img:require('../../static/images/oceania_img3.png')
			},
			{
				title:'工程造价',
				content:'和工程相关的专业学科，属于近几年来兴起的新行业，目的是降低工程建筑的风险，一个有效而且可靠地报价，能够减少在工程建筑中的损失，做好评估也更方便工作的展开。<br/><br/>就职也不局限在国企还是私企，大家需要学习的内容是非常多的，而且要与数字打交道，需要大家有比较好的基础，而且很多都是和房产等打交道，大家不用担心自己的工资收入。',
				img:require('../../static/images/oceania_img4.png')
			},
			{
				title:'精算学',
				content:'是商科近几年来发展起来的分支，它的职能主要是在经济活动中进行风险的评估，需要入职者有比较好的大局规划和意识，这部分的内容在学习的时候会比较困难，大家要保证自己得精力集中。<br><br>而未来的前景，主要是集中在保险业、投资业、证券业，专业的咨询公司对专业的人才需求量也是非常高的，大家要想出人头地，必须要保证自己得能力不断地进行提升。',
				img:require('../../static/images/oceania_img5.png')
			},
		]
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/oceaniaban.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>澳大利亚简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								澳大利亚的教育质量具备国际一流水准，拥有39所大学及数百所专科技术学院，大学排名世界靠前，学历含金量高，提供各类别的课程供国际学生选择。澳大利亚对国际学生无签证配额限制，签证通过率较高。<br/><br/>
								澳大利亚是典型的移民国家，被社会学家喻为“民族的拼盘”。近50年来，已先后有来自世界120个国家、140个民族移民到澳大利亚谋生和发展。澳大利亚政府允许留学生在课余时间打工，且本科和硕士的国际学生毕业后可获得2-3年的工作签证。<br/><br/>
								澳大利亚是世界上第一个颁布国际学生教育保护法的国家，该法案可以确保国际学生的正当权益，享受澳大利亚社会发展及物质文明所带来的成果。</div>
							<img className={'img'} src={require('../../static/images/oceania_img1.png')} alt=""/>
						</div>
						<div className={'title'}>
							<span>澳大利亚的留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>世界一流教育质量</div>
									<div className={'textModuleItemText textJust'}>澳大利亚大学虽然不多，但是其绝大部分大学都是公立大学以保证其教育质量。最新的世界大学排行榜中，其中8所澳大利亚5星大学全部进入世界百强，其中，澳大利亚国立大学、墨尔本大学、新南威尔士大学、昆士兰大学、悉尼大学更是位于世界前50名之列。充分显示了澳洲教育的学术品质。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>国际公认的学历学位</div>
									<div className={'textModuleItemText textJust'}>澳大利亚的教育体系享有极高的国际声誉，并以其有效的教育体系和创新政策闻名于世。目前，共有来自190多个国家和地区的约37万名海外学生持学生签证在澳大利亚求学。
										澳大利亚所颁发的学历学位使毕业生在国际和国内就业市场上备受雇主推崇。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>科学灵活的课程设置</div>
									<div className={'textModuleItemText textJust'}>持有学生签证在澳大利亚求学的海外学生所就读的课程，涵盖于澳大利亚学历资格框架（简称AQF）之下。该框架是由澳大利亚政府批准的全国性的学历资格评定框架，衔接全国的不同课程和学历资格。
										学生可以在不同层次的学习和不同院校间方便地转换，以往学习所获学分得到承认。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>完善健全的权益保障</div>
									<div className={'textModuleItemText textJust'}>澳大利亚专门制定了相关法律，旨在为海外学生提供优质的教育服务，并保障其消费者权利，上述法律统称为海外学生教育服务法律体系（简称ESOS）。
										它明确规定澳大利亚学校对招收海外学生的职能和职责，切实保护持学生签证在澳大利亚留学的海外学生。
									</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>合理低廉的留学费用</div>
									<div className={'textModuleItemText textJust'}>作为全球生活水平最高的国家之一，澳大利亚与其他许多国家相比，其生活费用和学习费相对低廉。此外，海外学生享有在澳大利亚每周 2 0小时的打工时间，可以赚取部分生活费。
										2012年新政实施后，所有赴澳就读本硕博课程的学生，在办理签证申请时，已不再需要向移民局提供担保金。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>非常适合移民的国家</div>
									<div className={'textModuleItemText textJust'}>在2010年，全球生活品质排行榜中，澳洲名列第二，成为最适于居住的国家之一。澳大利亚包容和谐的多元文化，一直深受移民者的青睐。由于其移民国家的特质，社会文化中并不存在 种族歧视 ，各种肤色的人在这里和谐共处。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>安宁祥和的生活环境</div>
									<div className={'textModuleItemText textJust'}>澳大利亚的低犯罪率和严格的 枪支管理法 可以确保海外学生享有一个安全的学习和旅游环境。澳大利亚环境舒适、安宁，学生可以安心学习并可自由旅行。
										作为享有世界最高水平的国家之一，澳大利亚拥有现代化的交通运输系统，便捷的通讯以及一流的健康医疗服务。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>秀丽迷人的自然风光</div>
									<div className={'textModuleItemText textJust'}>澳大利亚绮丽的自然风光令无数学生欣然向往。您可以利用假期尽情一探澳大利亚独特多样的地貌。从洒满阳光的海滩到银装素裹的滑雪场，从植被茂盛的热带雨林到远古的内陆石阵，选择尽在您的掌握之中。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>高效透明的签证过程</div>
									<div className={'textModuleItemText textJust'}>澳大利亚的低犯罪率和严格的 枪支管理法 可以确保海外学生享有一个安全的学习和旅游环境。澳大利亚环境舒适、安宁，学生可以安心学习并可自由旅行。
										作为享有世界最高水平的国家之一，澳大利亚拥有现代化的交通运输系统，便捷的通讯以及一流的健康医疗服务。</div>
								</div>
							</div>
							<div className={'textModuleItem'}>
								<div className={'textModuleItemFlexWrap'}>
									<div className={'textModuleItemTitle'}>物超所值的留学经历</div>
									<div className={'textModuleItemText textJust'}>澳大利亚拥有世界一流的教学质量，科学灵活的教学体系，完善健全的权益保障，经济合理的留学费用，秀丽迷人的自然风光。
										留学好比是一项长期投资，并不一定非要选择最贵或最便宜的，而是要选择最适合自己、性价比最高的。留学澳大利亚，给你一次物超所值的留学经历。</div>
								</div>
							</div>
						</div>
						<div className={'title'}>
							<span>澳洲热门专业</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.list.map((item,index)=>(
									<CardItem item={item} key={index}/>
								))
							}
						</div>
						<div className={'title'}>
							<span>澳洲八大及名校介绍</span>
							<span className={'line'}/>
						</div>
						<div className={'mingxiao'}>
							{
								this.state.mingxiao.map((item,index)=>{
									return (
										<div className={'mingxiaoItem'} key={index}>
											<div className={'mingxiaoItemTitle'}>{item.name}</div>
											<div className={'mingxiaoItemText'} dangerouslySetInnerHTML={{__html:item.content}}/>
											<div className={'mingxiaoItemZhuanYe'}>
												{
													item.zhuanye.map((item,index)=>{
															return <div className={['mingzhuanye',index===0?'on':null].join(' ')} key={index}>{item}</div>
													})
												}
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Australia